function init() {
    $('form#commentform').on('submit', function (){
        $('#addReviewPopup').append('<div class="loader-wrapper loader-wrapper--category" style="z-index: 10;"><span class="loader"></span></div>');
    });
}

export default {init};



// WEBPACK FOOTER //
// ./src/scripts/reviews-form.js